import { Component, OnInit } from '@angular/core';
import { UserLogin, User } from '../../model/user-login';
import { AuthServiceService } from '../../service/auth-service.service';
import { UserService } from '../../../section/user/service/user.service';
import { Router} from '@angular/router'; 
@Component({
  selector: 'app-left-sidebar',
  templateUrl: './left-sidebar.component.html',
  styleUrls: ['./left-sidebar.component.css']
})
export class LeftSidebarComponent implements OnInit {
  authService : AuthServiceService;
  router: Router;
  userService : UserService;
  user : any;
  isSuperAdmin : boolean = false;
  isDoctor : boolean = false;
  isBDA : boolean = false;
  isAssistant : boolean = false;
  constructor(authorizationService : AuthServiceService, route :Router,private _UserService: UserService  ) {
    this.authService = authorizationService;
    this.userService = _UserService;
     this.router = route;
     if(this.authService.getUserRole() === "1") {
        this.isSuperAdmin = true;
     } else if(this.authService.getUserRole() === "2") {
       this.isDoctor = true;
     } else if(this.authService.getUserRole() === "3") {
      this.isAssistant = true;
    } else if(this.authService.getUserRole() === "4") {
      this.isBDA = true;
    }

  }

  ngOnInit() {
      this.user = JSON.parse(sessionStorage.getItem("User"));
      if(this.user=== undefined || this.user=== null) {
          this.getUserDetail();
      }  
  }
  getUserDetail() {
    this.userService.getUserProfile().subscribe(data=>{
       if(data.length>0) {
       
        this.user = data[0];
        sessionStorage.setItem("User",JSON.stringify(data[0]));
      
        window.location.reload();
      }
      
    },error => {
       this.logout();
    })
  }
  logout() {
     if(this.authService.logout()) {
       sessionStorage.clear();
        window.location.href="/admin/#/login";
     }
  }

}



// WEBPACK FOOTER //
// ./src/app/component/home/left-sidebar/left-sidebar.component.ts